import Vue from 'vue';
import Component from 'vue-class-component';

import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';
import * as Bluebird from 'bluebird';
import * as _ from 'lodash';
import { slug } from '@/utils/index';
import { NodeObjectModel, Dispatcher, IProductDefinition, ProductDefinitions, NodeObjectRepository } from '@/models/assembly';
import { IAssembyProductCategory, IAssemblyProductConfig } from '@/models/config';
import SekilliImage from './SekilliImage.vue';




@Component({
  components: {
    sekilliImage: SekilliImage,

  },
})
export default class AssemblyMenu extends Vue {
  @Prop() selectedProductId: string;

  public get productCategories() {
    const categories = Store.state.assemblyConfig.categories;
    return _.sortBy(categories, x => x.title).reverse();
  }
  public getCategoryFamilys(category: IAssembyProductCategory): any[] {
    const products = Store.state.assemblyConfig.products;
    const famliyList = [];
    products.forEach((p) => {
      if (p.categoryIds.indexOf(category.id) > -1) {
        famliyList.push(p.familyId);
      }
    });

    return _.uniq(famliyList);
  }
  public getCategoryProducts(category: IAssembyProductCategory): IAssemblyProductConfig[] {
    const products = Store.state.assemblyConfig.products;

    return _.filter(products, p => _.includes(p.categoryIds, category.id));
  }

  public resolveImagePath(img: string): string {
    return process.env.PUBLIC_PATH + img;
  }

  public slug(val: string) {
    return slug(val);
  }

  public applyAdaptiveTextColor(params: any) {


    // http://www.w3.org/TR/AERT#color-contrast
    const o = Math.round(((parseInt(params.rgb.r, 10) * 299) +
      (parseInt(params.rgb.g, 10) * 587) +
      (parseInt(params.rgb.b, 10) * 114)) / 1000);
    const textColor = (o > 125) ? '#212529' : 'white';

    const el: any = this.$refs['text-' + params.dataKey][0];
    if (el) {

      el.style.color = textColor;
    }

  }

  created() {

    let product = _.find(Store.state.assemblyConfig.products, x => x.id === this.selectedProductId);
    if (!product) {
      product = Store.state.assemblyConfig.products[0];
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/assembly/AssemblyNav.ts